import {h, Component} from 'preact';
import Message from '../Message'
import messageStyle from '../style.scss'
import TextDisplay from '/chat/src/components/TextDisplay';

export default class OnlineFormular extends Component{
    render(){
        var forms = this.props.entry.meta.details.forms
        return (
            <div className={messageStyle.MessageWrapper}>
                <div
                    class={`message message--right message--single`}
                >
                    <div class='message__body'>
                        <TextDisplay text={this.props.entry.entry_body}/>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MetaMessage/OnlineFormular.js